import React, { useState, useEffect } from "react";
import { View, Text, ScrollView, TouchableOpacity, Linking } from "react-native";

import AsyncStorage from '@react-native-async-storage/async-storage';
import { FontAwesome5 } from "@expo/vector-icons";
import { MaterialIcons, Feather } from "@expo/vector-icons";

import HeaderDefault from "../../components/HeaderDefault";
import styles from "./styles";

const MyAccount = ({ navigation }) => {
  const [level, setLevel] = useState(1);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const levelUser = await AsyncStorage.getItem('level');

    setLevel(parseInt(levelUser));
  }

  return (
    <>
      <HeaderDefault title={'Minha Conta'} />

      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={styles.container}>
          <View style={styles.contentTitle}>
            <FontAwesome5 name="address-card" size={24} color="#32BFB1" />
            <Text style={styles.title}>CADASTRO</Text>
          </View>

          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('UpdateRegistration')}>
                <Text style={styles.textItemList}>Atualizar Cadastro</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('ReportIncome')}>
                <Text style={styles.textItemList}>Informe de Rendimentos</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            {
              level >= 2 ? (
                <View style={styles.itemList}>
                  <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('IncomeVoucher')}>
                    <Text style={styles.textItemList}>Comprovante de Renda</Text>
                    <MaterialIcons
                      name="keyboard-arrow-right"
                      size={25}
                      color="#2C2C2E"
                    />
                  </TouchableOpacity>
                  <View style={styles.hrLine}></View>
                </View>
              ) : (<></>)
            }
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('BankAccount')}>
                <Text style={styles.textItemList}>Conta Bancária</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            {
              level >= 2 ? (
                <>
                  <View style={styles.itemList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('InvestorProfile')}>
                      <Text style={styles.textItemList}>Perfil do Investidor</Text>
                      <MaterialIcons
                        name="keyboard-arrow-right"
                        size={25}
                        color="#2C2C2E"
                      />
                    </TouchableOpacity>
                    <View style={styles.hrLine}></View>
                  </View>

                  <View style={styles.itemList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('LevelUpdate')}>
                      <Text style={styles.textItemList}>Atualização de nível</Text>
                      <MaterialIcons
                        name="keyboard-arrow-right"
                        size={25}
                        color="#2C2C2E"
                      />
                    </TouchableOpacity>
                    <View style={styles.hrLine}></View>
                  </View>
                </>
              ) : null
            }
          </View>

          <View style={styles.contentTitle}>
            <Feather name="lock" size={24} color="#32BFB1" />
            <Text style={styles.title}>SEGURANÇA</Text>
          </View>
          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('ChangePassword')}>
                <Text style={styles.textItemList}>Alterar senha</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            {/* <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate('MyCards')}>
                <Text style={styles.textItemList}>Meus cartões</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View> */}
          </View>

          <View style={styles.contentTitle}>
            <Feather name="help-circle" size={24} color="#32BFB1" />
            <Text style={styles.title}>AJUDA</Text>
          </View>
          <View style={styles.list}>
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => {
                //navigation.navigate('TermsService')
                Linking.canOpenURL('https://api.gpxexchange.com.br/termos-privacidade').then(supported => {
                  if (supported) {
                    Linking.openURL('https://api.gpxexchange.com.br/termos-privacidade');
                  } else {
                    console.log('url blocked');
                  }
                });
              }}>
                <Text style={styles.textItemList}>Termos de Uso</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
            <View style={styles.itemList}>
              <TouchableOpacity style={styles.contentItemList} onPress={() => {
                Linking.canOpenURL('https://gpxexchange.com.br/help').then(supported => {
                  if (supported) {
                    Linking.openURL('https://gpxexchange.com.br/help');
                  } else {
                    //console.log('url blocked');
                  }
                });
              }}>
                <Text style={styles.textItemList}>Central de Ajuda</Text>
                <MaterialIcons
                  name="keyboard-arrow-right"
                  size={25}
                  color="#2C2C2E"
                />
              </TouchableOpacity>
              <View style={styles.hrLine}></View>
            </View>
          </View>
        </View>
        <Text
          style={styles.textLogout}
          onPress={async () => {await AsyncStorage.removeItem("keep_logged"); navigation.navigate("Login");}}
        >
          SAIR DA CONTA
        </Text>
      </ScrollView>
    </>
  );
};

export default MyAccount;

